import React, {Component} from 'react';

import './styles.scss';


export default class Category extends Component {

    render() {
        return (
            <div className={"category-pyramid"} onClick={this.props.onClick}>
                <div className={"color"} style={{backgroundColor:this.props.color}}/>
                <div className={"name"}>{this.props.name}</div>
                <div className={"description"}>{this.props.description}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/pyramidPerSegment/components/category/Category.js